import { useEffect } from 'react';

import { LISTENING_SCREEN_STORES } from 'lib/zustand';
import { askAiStoreActions } from 'modules/ask-ai/store';
import { useSettingsStore } from 'modules/settings-sync/store';
import { useSpeedStore } from 'modules/speed/store/speedStore';
import { useVoiceStore } from 'modules/voices/hooks';

import { playbackStoreActions } from '../stores/playback/playbackStore';

export function useCleanUpListeningExperience() {
  useEffect(() => {
    return () => {
      cleanUpStores();
    };
  }, []);
}

export async function cleanUpStores(isLogout: boolean = false) {
  playbackStoreActions.cleanup();
  LISTENING_SCREEN_STORES.forEach(store => store.reset());
  useVoiceStore.reset(); // TODO(albertusdev): support indexeddb listening screen stores automatic cleanup instead of calling each store here.
  useSpeedStore.reset();
  await askAiStoreActions.cleanUpAskAi(isLogout);

  if (isLogout) {
    useSettingsStore.reset();
  }
}
